import _ from 'lodash';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { MENUS } from '@/constants';
import { estEncaissementDirect } from '@/utils';
import { useRegieStore } from '@/zustand';

/**
 * Cloisonne l'onglet ouvert en encaissement direct (LOOC) : toute autre URL (retour arrière,
 * saisie manuelle…) est ramenée sur /encaissement-direct, une fois la régie du lien sélectionnée.
 * Purge aussi les paramètres du lien (TOKEN, infoSup, identifiants…) de la barre d'adresse :
 * à ce stade l'authentification est faite et le mode est mémorisé en sessionStorage.
 */
const EncaissementDirectGuard = () => {
  const history = useHistory();
  const location = useLocation();
  const regieSelectionnee = useRegieStore((state) => !!state.regie?.identifiant);

  React.useEffect(() => {
    const pathEncaissementDirect = MENUS.LOCATIONS[MENUS.MENU_ENCAISSEMENT_DIRECT];

    if (
      estEncaissementDirect() &&
      regieSelectionnee &&
      (location.pathname !== pathEncaissementDirect || !_.isEmpty(location.search))
    ) {
      history.replace(pathEncaissementDirect);
    }
  }, [history, location.pathname, location.search, regieSelectionnee]);

  return null;
};

export default EncaissementDirectGuard;
